import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Smartphone, Share, PlusSquare, Check } from "lucide-react";

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const IOS_STEPS = [
  [Share, "Open this site in Safari and tap the Share button (the square with an arrow) at the bottom of the screen."],
  [PlusSquare, "Scroll down the share sheet and tap \"Add to Home Screen\"."],
  [Check, "Tap \"Add\" in the top-right corner. The XAU Terminal icon appears on your Home Screen — open it like any app."],
];
const ANDROID_STEPS = [
  [Share, "Open this site in Chrome and tap the ⋮ menu in the top-right corner."],
  [PlusSquare, "Tap \"Add to Home screen\" (or \"Install app\")."],
  [Check, "Confirm. The app icon appears on your home screen and opens full-screen."],
];

export function InstallDialog({ trigger }) {
  const steps = isIOS() ? IOS_STEPS : ANDROID_STEPS;
  const url = window.location.origin;
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="install-dialog" className="bg-[#0A0D14] border-white/10 text-[#F9FAFB] max-w-md w-[calc(100vw-1.5rem)] sm:w-full overflow-hidden">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <Smartphone size={20} className="text-[#F59E0B]" /> Install on your phone
          </DialogTitle>
          <DialogDescription className="text-sm text-[#9CA3AF] leading-relaxed text-left">
            Add XAUUSD AI Terminal to your Home Screen for one-tap, full-screen access — no app store needed. You stay signed in and get the same live data.
          </DialogDescription>
        </DialogHeader>
        <div className="glass rounded-2xl p-4 flex items-center gap-3 min-w-0">
          <img src="/apple-touch-icon.png" alt="App icon" className="w-14 h-14 rounded-xl shrink-0" />
          <div className="min-w-0">
            <div className="font-semibold">XAU Terminal</div>
            <div data-testid="install-url" className="text-xs text-[#9CA3AF] font-mono-num break-all">{url}</div>
          </div>
        </div>
        <ol className="space-y-3 mt-1">
          {steps.map(([Icon, text], i) => (
            <li key={i} className="flex items-start gap-3 text-sm text-[#D1D5DB] leading-relaxed">
              <span className="shrink-0 w-7 h-7 rounded-full bg-[#F59E0B]/15 border border-[#F59E0B]/40 text-[#F59E0B] grid place-items-center font-bold text-xs">{i + 1}</span>
              <span className="flex items-start gap-2"><Icon size={16} className="text-[#F59E0B] mt-0.5 shrink-0" />{text}</span>
            </li>
          ))}
        </ol>
        <p className="text-xs text-[#6B7280] mt-1">Tip: on iPhone this only works from Safari, not from the Facebook or WhatsApp in-app browser — tap "Open in Safari" first.</p>
      </DialogContent>
    </Dialog>
  );
}
